import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import Application from './components/application';
import { Auth0Provider } from '@auth0/auth0-react';
// import * as Sentry from '@sentry/react';
import { RecoilRoot, atom, selector, useRecoilState, useRecoilValue } from 'recoil';
import { StyledEngineProvider } from '@mui/material';
import { loadUsetifulScript } from 'usetiful-sdk';
import './index.css';

// Sentry.init({
// 	dsn: 'https://5e2a317b6344fe1d99aecdee9e6fa5f9@o919032.ingest.sentry.io/4505992232566784',
// 	environment: window.location.hostname === 'studio.nuqlea.com' ? 'production' : 'dev',
// 	tracesSampleRate: 1.0,
// 	replaysSessionSampleRate: 0.1,
// 	replaysOnErrorSampleRate: 1.0,
// 	integrations: [new Sentry.Replay()],
// });

loadUsetifulScript('bc6515f802c384e3282ce1680b28aeda');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<React.StrictMode>
		<Auth0Provider
			domain={process.env.REACT_APP_AUTH0_DOMAIN || ''}
			clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || ''}
			authorizationParams={{
				redirect_uri: window.location.origin,
				audience: process.env.REACT_APP_AUTH0_AUDIENCE || '',
				scope: 'openid profile email user_metadata app_metadata',
			}}
		>
			<RecoilRoot>
				<StyledEngineProvider injectFirst>
					<Application />
				</StyledEngineProvider>
			</RecoilRoot>
		</Auth0Provider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
